import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Amenities banner',
    },
  },
};


export function AmenitiesHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="amenitieshero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Amenities banner"
    >
      <InnerPageHeroSubtitle path="amenitieshero.subtitle" />
      <RichTextContent
        path="amenitieshero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="amenitieshero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="amenitieshero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AmenitiesHero',
  displayName: 'Amenities Hero',
  tokens: {
    'amenitieshero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Amenities</p>',
    },
    'amenitieshero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Apartment Amenities in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'amenitieshero.bg_image': bgImageDef,
  },
};

(AmenitiesHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default AmenitiesHero;
